import { render, staticRenderFns } from "./home-dashboard-dyn.vue?vue&type=template&id=38b36aea&"
import script from "./home-dashboard-dyn.vue?vue&type=script&lang=js&"
export * from "./home-dashboard-dyn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports